import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './authContext';
import { LoaderPage } from '../components';


const PrivateRoute: React.FC = () => {
  const { isLoggedIn } = useAuth();

  if (isLoggedIn === null) {
    return <LoaderPage />;
  }
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;